import React, {Component} from 'react';
import {Link, withRouteData} from 'react-static';
import styled from 'styled-components';

import { acceptCookies, getAcceptStatus } from '../utils/CookiesHelper';

const CookieDisclaimerStyle = styled.div`

	position: fixed;
	will-change: transform;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 10000;
	
	.cookie-button {
		background-color: transparent;
		border: 0;
		color: inherit;
		cursor: pointer;
		font: inherit;
		border-style: solid;
		border-width: 0.0625em;
		padding: 0.5em 1em;
		border-radius: 2px;
		height: 100%;
		
		:focus, :hover {
			border-color: #83F5F8;
			color: #83F5F8;
		    background: rgba(131, 245, 248, 0.1);
		}
	}
	
	.cookie-disclaimer {
		background-color: rgba(33, 33, 33, 1);
		color: #fff;
		font-size: 0.8em;
		padding: 0.75em;
		z-index: 100;
		width: 100%;
		margin: auto;
		
		p {
			margin: 0;
			
			@media screen and (max-width: 1023px) {
	            margin-bottom: 1em;
			}
		}
	}
`;

class CookieDisclaimer extends Component {

	constructor(props) {
		super(props);

		this.state = {
			cookiesAccepted: getAcceptStatus()
		};

		this.handleCookieClose = this.handleCookieClose.bind(this);
	}

	handleCookieClose() {
		acceptCookies();
		this.setState({
			cookiesAccepted: +new Date()
		});
	}

	render() {

		return (
			<CookieDisclaimerStyle>
				{ !this.state.cookiesAccepted &&
					<div className="cookie-disclaimer js-cookie-disclaimer">
						<div className="row collapse">
							<div className="columns small-12 large-9">
								<p>{ this.props.cookieDisclaimer.disclaimer } <Link className="cyan" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/privacy-policy`}>{ this.props.footer.privacyPolicy }</Link></p>
							</div>
							<div className="columns small-12 large-2 large-offset-1">
								<button className="cookie-button" onClick={this.handleCookieClose}>{ this.props.cookieDisclaimer.close }</button>
							</div>
						</div>
					</div>
				}
			</CookieDisclaimerStyle>
		)
	}
}

export default withRouteData(CookieDisclaimer)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/CookieDisclaimer.js